import { MONTHS_TO_BE_CONSIDERED_NOT_TRIAL } from '../../domain/_screens/header/header-bottom-constants';

const isToday = (someDate) => {
    const today = new Date();
    const isSameDay = someDate.getDate() === today.getDate();
    const isSameMonth = someDate.getMonth() === today.getMonth();
    const isSameYear = someDate.getFullYear() === today.getFullYear();
    return isSameDay && isSameMonth && isSameYear;
};

export default isToday;

export const getMonthBetweenDates = (startDate, endDate) => {
    const parsedEndDate = new Date(Date.parse(endDate));
    const todayDate = new Date(startDate);

    const todayYear = todayDate.getFullYear();
    const endYear = parsedEndDate.getFullYear();

    const todayMonth = todayDate.getMonth();
    const endMonth = parsedEndDate.getMonth();

    const endCalculusDate = (endMonth + MONTHS_TO_BE_CONSIDERED_NOT_TRIAL * endYear);
    const todayCalculusDate = (todayMonth + MONTHS_TO_BE_CONSIDERED_NOT_TRIAL * todayYear);

    return (endCalculusDate - todayCalculusDate);
};
